export default "__VITE_ASSET__B1gf69bk__"